let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("rFPjj")).then(() => parcelRequire('juA5l'));